export default function getHost(url) {
    try {
        const urlObj = new URL(url);
        const host = urlObj.hostname;

        // Limitar la longitud a 20 caracteres
        const hostCorto = host.length <= 25 ? host : host.substring(0, 25);

        return hostCorto;
    } catch (error) {
        console.error('Error al procesar la URL:', error.message);
        return null;
    }
}
